/**
 * Словник: cs.
 * Згенеровано tool/gen_web_locales.py з lib/l10n/app_cs.arb — руками не правити.
 *
 * ⚠️ Новий рядок: спершу в ARB усіх мов, потім ключ у en.ts і перегенерація.
 * Паритет ключів перевіряється на збірці (npm run check:i18n).
 */
export default {
  waiting: "⏳ Čekání na druhého účastníka...",
  connectionLost: "Spojení bylo přerušeno",
  peerLeft: "👋 Druhý účastník opustil hovor",
  connectionError: "🚫 Chyba připojení",
  connectionFailedTryAgain: "🚫 Nepodařilo se připojit k serveru. Zkuste to prosím znovu.",
  reconnectionFailed: "🚫 Spojení bylo přerušeno. Obnovit ho se nepodařilo (počet pokusů: {attempts}).",
  connectionErrorWithDetails: "🚫 Chyba připojení: {error}",
  speakerLoud: "Nahlas",
  speakerEar: "Ucho",
  copyRoomId: "Kopírovat ID místnosti",
  share: "Sdílet",
  linkCopied: "🔗 Odkaz zkopírován!",
  idCopied: "🆔 ID zkopírováno!",
  startMeeting: "Zahájit schůzku",
  chooseAction: "Vyberte akci",
  createNewRoom: "Nová místnost",
  scheduleCall: "Naplánovat hovor",
  calendarOpened: "📅 Kalendář byl otevřen",
  linkCopiedToClipboard: "🔗 Odkaz zkopírován do schránky",
  enterRoomId: "ID místnosti",
  roomIdValidationError: "ID místnosti smí obsahovat pouze písmena, číslice a pomlčky",
  joinRoom: "PŘIPOJIT",
  termsAndPrivacyHelp: "Podmínky a soukromí | Nápověda",
  invite: "Pozvat",
  mySettings: "Moje nastavení",
  peerSettings: "Nastavení druhé strany",
  blockRemoteControl: "Blokovat vzdálené ovládání",
  iAgreeToTerms: "Souhlasím s podmínkami služby",
  termsOfUse: "Podmínky použití",
  privacyPolicy: "Zásady ochrany osobních údajů",
  howToUse: "Jak používat",
  termsAcceptanceRequired: "Pro používání služby musíte souhlasit s podmínkami",
  ok: "OK",
  permissionsRequired: "Vyžadována oprávnění",
  permissionsNeededMessage: "Aplikace ke správnému fungování potřebuje tato oprávnění:",
  permissionsNote: "Poznámka: Když změníte oprávnění v Nastavení, iOS aplikaci restartuje. Je to normální.",
  permissionsEnableMessage: "Chcete-li pokračovat, povolte tato oprávnění v nastavení zařízení.",
  cancel: "Zrušit",
  openSettings: "Otevřít nastavení",
  websocketError: "Chyba WebSocketu",
  roomFull: "Místnost je plná",
  timeExpired: "Čas vypršel",
  remaining: "zbývá",
  mediaPermissionsRequired: "Videohovory vyžadují přístup ke kameře a mikrofonu. Udělte prosím oprávnění v prohlížeči.",
  mediaPermissionsRequiredMobile: "Videohovory vyžadují přístup ke kameře a mikrofonu. Udělte prosím oprávnění v nastavení aplikace.",
  browserSettings: "Nastavení prohlížeče",
  openAppSettings: "Otevřít nastavení",
  grantPermissions: "Udělit oprávnění",
  permissionsNotGranted: "Oprávnění nebyla udělena. Chcete-li pokračovat, udělte je prosím.",
  permissionRequestError: "Chyba při žádosti o oprávnění: {error}",
  camera: "Kamera",
  microphone: "Mikrofon",
  cameraDescription: "Pro přenos videa",
  microphoneDescription: "Pro přenos zvuku",
  continueWithoutPermissions: "Pokračovat bez oprávnění",
  mediaPermissionsRequiredFallback: "Videohovory vyžadují oprávnění k médiím. Udělte je prosím v nastavení prohlížeče.",
  mediaPermissionsRequiredMobileFallback: "Videohovory vyžadují oprávnění k médiím. Udělte je prosím v nastavení aplikace.",
  browserSettingsFallback: "Nastavení prohlížeče",
  openAppSettingsFallback: "Otevřít nastavení",
  permissionsPermanentlyDenied: "Oprávnění byla trvale zamítnuta. Povolte je prosím v nastavení aplikace.",
  continueText: "Pokračovat",
  mirror: "Zrcadlit",
  fitContain: "Přizpůsobit",
  fitCover: "Vyplnit",
  switchCamera: "Otočit",
  block: "Blokovat",
  pip: "PiP",
  mic: "Mikrofon",
  video: "Video",
  speaker: "Reproduktor",
  readyToConnect: "Můžeme začít?",
  startOneOnOne: "Zahájit videohovor",
  createPrivateLink: "Odkaz hotový za vteřinu",
  welcomeExplainer: "Vytvořte odkaz a pošlete ho komukoli. Otevře se i bez aplikace.",
  joinHaveLink: "Máte odkaz?",
  joinFieldHint: "Vložte odkaz nebo ID",
  roomInputInvalid: "Vložte odkaz na hovor nebo ID místnosti (písmena, číslice a pomlčky)",
  guestTitle: "Máte pozvánku na videohovor",
  guestBody: "Místnost je připravená. Druhá strana vás uvidí, jakmile se připojíte.",
  guestJoin: "Připojit se",
  guestFreeNote: "Připojení je vždy zdarma",
  guestCreateOwn: "Vytvořit vlastní místnost",
  guestInvalidTitle: "Odkaz je zřejmě poškozený",
  guestInvalidBody: "Požádejte o odkaz znovu, nebo si vytvořte vlastní místnost.",
  inviteCardTitle: "Vaše místnost je připravená",
  inviteCardBody: "Pošlete odkaz tomu, s kým chcete mluvit",
  inviteShareLink: "Sdílet odkaz",
  inviteCopy: "Kopírovat",
  inviteBrowserHint: "Otevře se v jakémkoli prohlížeči. Aplikaci není třeba instalovat.",
  inviteSentHint: "Odesláno? Druhá strana se tu objeví, jakmile otevře odkaz.",
  inviteShareMessage: "Připoj se k mému videohovoru v One2One 👋\nStačí otevřít odkaz. Funguje v prohlížeči a nemusíš nic instalovat:\n{link}",
  copyLink: "Kopírovat odkaz",
  consentBannerText: "Můžeme shromažďovat statistiky používání? Ukazují nám, které funkce lidé používají. Obsah hovorů v nich nikdy není.",
  consentAllow: "Povolit",
  consentDeny: "Nepovolit",
  privacySettingsLink: "Nastavení statistik",
} as const;
